import Heading from './Heading'

export default Heading




// WEBPACK FOOTER //
// ./src/components/Heading/index.js